import { useContext } from 'react';
import { DrawContext } from '../components/DrawsContext.js';
/**
 * Returns the active draw object.
 *
 * @returns Draw object
 * @throws {Error} if the hook is used outside of the DrawProvider
 */
export function useCurrentDrawInfo() {
    const draw = useContext(DrawContext);
    if (!draw) {
        throw new Error('DrawProvider must be used within suitable provider with DrawContext');
    }
    return draw;
}
//# sourceMappingURL=useCurrentDrawInfo.js.map